// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.row[data-v-6de2f885] {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: row;\n}\n.row div[data-v-6de2f885] {\r\n        margin-right: 3em;\r\n        justify-content: space-between;\n}\n.row .equation[data-v-6de2f885] {\r\n        width: 100%;\n}\n[data-v-6de2f885] .autoCompleteContainer input {\r\n        display: none;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
